/* eslint-disable no-unused-vars */
import React, { useContext, useState, useEffect, useRef } from 'react';
import useStyles from '../useStyles';
import { DialogContext } from '../../../contexts/DialogContext';
import { dialogActions } from '../../../reducers/dialogReducer';
import PowderBatchTemperatureTableToolbar from './SettingsConfigPowderBatchTemperatureToolbar';
import SettingConfigPowderBatchTemperatureTable from './SettingConfigPowderBatchTemperatureTable';
import styleConst from '../../../constants/style';
import useAxios from '../../../hooks/useAxios';
import useCancelToken from '../../../hooks/useCancelToken';
import Typography from '../../../components/Typography/Typography';
import PaperContainer from '../../../components/PaperContainer/PaperContainer';
import TablePagination from '../../../components/TablePagination/TablePagination';
import Snackbar from '../../../components/Snackbar/Snackbar';
import {
  addPowderBatchTemperature,
  deletePowderBatchTemperature,
  getPowderBatchTemperatureList,
} from '../../../services/settings-config';

const SettingsConfigPowderBatchTemperature = () => {
  const { classes } = useStyles();
  const [isLoading, setIsLoading] = useState(true);
  const [currentPage, setCurrentPage] = useState(1);
  const [totalRows, setTotalRows] = useState(0);
  const [powderBatchList, setPowderBatchList] = useState([]);
  const [statusMsg, setStatusMsg] = useState('');
  const [statusType, setStatusType] = useState('success');
  const [showStatus, setShowStatus] = useState(false);
  const [editedData, setEditedData] = useState({});
  const snackbarTimer = useRef(null);
  const { dialogDispatch } = useContext(DialogContext);
  const { newCancelToken } = useCancelToken();

  const rowsPerPage = styleConst.ROWS_PER_PAGE;

  const openSnackbar = () => {
    setShowStatus(true);
    clearTimeout(snackbarTimer.current);
    snackbarTimer.current = setTimeout(() => {
      setShowStatus(false);
      clearTimeout(snackbarTimer.current);
    }, 3000);
  };

  const getPowderBatchConfig = async (page = currentPage, keyWord, isFromLastPage = false) => {
    const data = keyWord
      ? { page: page - 1, keyWord, size: rowsPerPage }
      : { page: page - 1, size: rowsPerPage };
    const cancelToken = newCancelToken();
    await getPowderBatchTemperatureList({
      data,
      cancelToken,
      onSuccess: (result) => {
        const { count, powderBatch } = result;
        setTotalRows(count);
        setPowderBatchList(
          powderBatch.map((item) => ({
            rowId: item,
            powderBatch: item,
          }))
        );
        setIsLoading(false);
      },
      onError: (result, _rtCode, noPrivilegeMsg) => {
        if (isFromLastPage || currentPage <= 1) {
          dialogDispatch({
            type: dialogActions.OPEN,
            config: {
              title: '無法取得試燒環溫度設定',
              message:
                noPrivilegeMsg ||
                `目前無法取得試燒環溫度設定，請確認網路是否正常或聯繫軟體部門：${result}`,
            },
          });
          return;
        }
        setCurrentPage(currentPage - 1);
        getPowderBatchConfig(currentPage - 1, '', true);
      },
    });
  };

  const handleEditData = async () => {
    const data = {
      detect: [
        {
          ...editedData,
          isEnabled: 1,
        },
      ],
    };
    const cancelToken = newCancelToken();
    const [status, result, rtCode, noPrivilegeMsg] = await useAxios(
      '/transDetectSetting',
      data,
      true,
      cancelToken
    );
    if (status) {
      setStatusMsg('已成功更新Defect Type設定！');
      setStatusType('success');
      getPowderBatchConfig();
    } else {
      setStatusType('error');
      setStatusMsg(noPrivilegeMsg || '更新Defect Type設定失敗，請稍後再試，或通知網管人員！');
    }
    openSnackbar();
    setEditedData({});
  };

  const onAddPowderBatchTemperatureSuccess = () => {
    getPowderBatchConfig();
    setStatusMsg('新增溫度表成功！');
    setStatusType('success');
    openSnackbar();
  };

  const handleChangePage = (newPage) => {
    setCurrentPage(newPage);
    getPowderBatchConfig(newPage);
  };

  const handleRowDelete = async (targetRow) => {
    const { powderBatch } = targetRow;
    const data = { deviceId: Number(powderBatch) };
    const cancelToken = newCancelToken();
    await deletePowderBatchTemperature({
      data,
      cancelToken,
      onSuccess: () => {
        getPowderBatchConfig();
        setStatusMsg(`已成功刪除 ${powderBatch} 溫度表！`);
        setStatusType('success');
      },
      onError: (result, _rtCode, noPrivilegeMsg) => {
        setStatusType('error');
        setStatusMsg(noPrivilegeMsg || result);
      },
      onSettled: () => {
        openSnackbar();
      },
    });
  };

  useEffect(() => {
    setCurrentPage(1);
    getPowderBatchConfig();

    return () => {
      clearTimeout(snackbarTimer.current);
    };
  }, []);

  return (
    <PaperContainer className={classes.container}>
      <Typography variant="h6">試燒環溫度表設定</Typography>
      <PowderBatchTemperatureTableToolbar
        onAddPowderBatchTemperatureSuccess={onAddPowderBatchTemperatureSuccess}
      />
      <Snackbar msg={statusMsg} type={statusType} open={showStatus} className={classes.snackbar} />
      <SettingConfigPowderBatchTemperatureTable
        isLoading={isLoading}
        tableContentList={powderBatchList}
        editedData={editedData}
        onRowDelete={handleRowDelete}
      />
      <TablePagination
        isEditing={false}
        totalRows={totalRows}
        rowsPerPage={rowsPerPage}
        page={currentPage}
        onChangePage={handleChangePage}
      />
    </PaperContainer>
  );
};

export default SettingsConfigPowderBatchTemperature;
